import React, { useState, useEffect } from 'react';
import Slider from "react-slick";
import { fetchBanners } from '../../services/banners-api';
import { disconnect } from '../../utils';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { useLanguage } from '../../LanguageContext';

const Banner = () => {
    const [banners, setBanners] = useState([]);
    const { language, changeLanguage } = useLanguage();
    
    useEffect(() => {
        fetchBanners()
            .then(result => {
                if (result && result.data && result.data.Data && result.data.Data.Dados) {
                    let bannersResult = result.data.Data.Dados.filter(dado => dado.TipoFiltro == null);
                    
                    bannersResult = bannersResult.map(banner => {
                        const isExternal = banner.LinkRedirecionamento 
                            ? !banner.LinkRedirecionamento.includes('shimanomexico.com')
                            : false;
                        return {
                            ...banner,
                            LinkExterno: isExternal
                        };
                    });
                    
                   
    
                    const filteredBanners = bannersResult.filter(banner => {
                        const linkImagem = banner.LinkImagem || '';
                        
                        const isNeutral = !linkImagem.includes("_EN") && !linkImagem.includes("_ES");
    
                        if (language === "es-MX") {
                            return isNeutral || linkImagem.includes("_ES");
                        }
                        if (language === "en-US") {
                            return isNeutral || linkImagem.includes("_EN");
                        }
                        return isNeutral;
                    });
    
                    setBanners(filteredBanners); 
                } else {
                    console.error('Dados inesperados recebidos:', result);
                    disconnect();
                }
            })
            .catch(error => {
                console.error('Erro ao buscar banners:', error); 
            });
    }, [language]);
    

    

    const HaveLink = ({ banner }) => {
        if (banner.LinkRedirecionamento !== null) {
            return (
                <a href={banner.LinkRedirecionamento}>
                    <img src={banner.LinkImagem} alt="" style={{ margin: 'auto' }} />
                </a>
            )
        }
             
        return <img src={banner.LinkImagem} alt="" style={{ margin: 'auto' }} />
    }
      
    const CustomPrevArrow = (props) => {
        const { className, style, onClick } = props;
        return (
            <button
                className={`btn btn--icon btn-left ${className}`}
                onClick={onClick}
                style={{ ...style }}
            >
                <FaChevronLeft size={14} color="#000"/>
            </button>
        )
    }
    const CustomNextArrow = (props) => {
        const { className, style, onClick } = props;
        return (
            <button
                className={`btn btn--icon btn-right ${className}`}
                onClick={onClick}
                style={{ ...style }}
            >
                <FaChevronRight size={14} color="#000"/>
            </button>
        )
    }

  
  

    const settings = {
        dots: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover:true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        loop: true,
        arrows: true,
        prevArrow: <CustomPrevArrow />,
        nextArrow: <CustomNextArrow />
    };

    return (
        <>
            {banners &&
                <section className="carrossel_principal">
                    
                    <Slider {...settings}>
                        {banners.map((banner, index) => (
                            <div key={index}>
                                <HaveLink banner={banner} />
                            </div>
                        ))}
                    </Slider>
                </section>
            }
        </>
    )
}

export default Banner;